export const getFee = (feeId) => ({ fees: { feesList } }) =>
  feesList.find(({ id }) => id === +feeId);
